export const INPUT_LABELS = {
  NAME: 'first name',
  LAST_NAME: 'last name',
  EMAIL: 'email address',
  PASSWORD: 'password',
  PHONE: 'phone number',
  LANGUGE: 'preferred Language',
  ROLE: 'security role',
  POSITION: 'position',
};

export const TOAST_MESSAGES = {
  CREATE_USER: (email: string) => `User ${email} created successfully`,
  UPDATE_USER: (email: string) => `User ${email} updated successfully`,
  FAIL_USER_ASSIGN: 'User could not be assigned the specified role.  Please ask a super admin to assign the role to this user.',
};

export const ERROR_MESSAGES = {
  FAIL_USER: 'Failed to create user',
  FAIL_USER_ASSIGN: 'User could not be assigned the specified role.  Please ask a super admin to assign the role to this user.',
};

export const DEFAULT_VALIDATION_STATE = {
  firstName: '',
  lastName: '',
  email: '',
  role: '',
  phone: '',
};
